import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { api_gateway } from '../../../../conexoes/api.js'
import {
  revelarCriarContaSms,
  revelarRemoverContaSms
} from '../../../../redux/actions/index'
import MensagemErro from '../../../componentesModais/mensagens/mensagemErro.js'
import MensagemSucesso from '../../../componentesModais/mensagens/mensagemSucesso.js'
import MensagemAtencao from '../../../componentesModais/mensagens/mensagemAtencao.js'
import Botao from '../../../Mantine/Botao/index.jsx'
import Group from '../../../Mantine/Group/index.jsx'
import Modal from '../../../Mantine/Modal/index.jsx'

import * as S from './styles.js'
import { useGlobal } from '../../../../stores/useGlobal.js'

const ALERTAS = {
  padrao: {
    open: false,
    mensagem: '',
    titulo: ''
  },
  cadastrar: {
    titulo: 'Sucesso',
    open: true,
    mensagem: 'Conta SMS ativada com sucesso.'
  },
  deletar: {
    titulo: 'Sucesso',
    open: true,
    mensagem: 'Conta SMS desativada com sucesso.'
  },
  erroCadastrar: {
    titulo: 'Erro',
    open: true,
    mensagem: 'Falha ao ativar conta SMS.'
  },
  erroDeletar: {
    titulo: 'Erro',
    open: true,
    mensagem: 'Falha ao desativar conta SMS.'
  },
  naoPossuiConta: {
    titulo: 'Atenção',
    open: true,
    mensagem: ({ ds_pav_usuario, ds_email }) =>
      `A conta SMS do usuário ${ds_pav_usuario}, e-mail: ${ds_email} já está inativa. Nenhuma alteração foi realizada.`
  },
  possuiConta: {
    titulo: 'Atenção',
    open: true,
    mensagem: ({ ds_pav_usuario, ds_email }) =>
      `A conta SMS do usuário ${ds_pav_usuario}, e-mail: ${ds_email} já está ativa. Nenhuma alteração foi realizada.`
  },
  cadastroInativo: {
    titulo: 'Erro',
    open: true,
    mensagem: ({ ds_pav_usuario, ds_email }) =>
      `Não é possível ativar a conta SMS, pois o usuário ${ds_pav_usuario} portador do e-mail ${ds_email} está inativo na plataforma.`
  },
  deletarInativo: {
    titulo: 'Erro',
    open: true,
    mensagem: ({ ds_pav_usuario, ds_email }) =>
      `Não é possível desativar a conta SMS, pois o usuário ${ds_pav_usuario} portador do e-mail ${ds_email} está inativo na plataforma.`
  }
}

export default function CadastrarOuRemoverContaSms({
  linhaSelecionada,
  revelarAlertaCriarContaSms,
  revelarAlertaRemoverContaSms,
  onFinish
}) {
  const { setIsLoadingGlobal } = useGlobal()

  const {
    ds_pav_usuario,
    ds_email,
    userHasSMS,
    fl_ativo,
    cd_pav_usuario,
    smsActive,
    cd_sms_conta_usuario
  } = linhaSelecionada

  const despacho = useDispatch()
  const [alerta, setAlerta] = useState(ALERTAS.padrao)

  const isOpen = revelarAlertaCriarContaSms || revelarAlertaRemoverContaSms

  const isReativarContaSms =
    revelarAlertaCriarContaSms && cd_sms_conta_usuario && !smsActive

  useEffect(() => {
    const alertas = [
      {
        condicao: fl_ativo === 0 && revelarAlertaCriarContaSms,
        alerta: ALERTAS.cadastroInativo
      },
      {
        condicao: fl_ativo === 0 && revelarAlertaRemoverContaSms,
        alerta: ALERTAS.deletarInativo
      },
      {
        condicao: revelarAlertaCriarContaSms && userHasSMS,
        alerta: ALERTAS.possuiConta
      },
      {
        condicao: revelarAlertaRemoverContaSms && !userHasSMS,
        alerta: ALERTAS.naoPossuiConta
      }
    ]

    const alertaEncontrado = alertas.find((item) => item.condicao)

    if (alertaEncontrado) {
      setAlerta({
        ...alertaEncontrado.alerta,
        mensagem: alertaEncontrado.alerta.mensagem(linhaSelecionada)
      })
    }
  }, [isOpen, linhaSelecionada])

  const handleSubmit = async () => {
    setIsLoadingGlobal(true)
    const rota = revelarAlertaCriarContaSms ? 'alterar' : 'deletar'

    const payload = {
      userID: cd_pav_usuario
    }

    await api_gateway
      .post(`/m1/${rota}/smsUser`, payload)
      .then(() => {
        const alertType = rota === 'alterar' ? 'cadastrar' : rota

        setAlerta(ALERTAS[alertType])
      })
      .catch(() => {
        const alertType = revelarAlertaCriarContaSms
          ? 'erroCadastrar'
          : 'erroDeletar'

        setAlerta(ALERTAS[alertType])
      })
      .finally(() => setIsLoadingGlobal(false))
  }

  const handleClose = () => {
    if (revelarAlertaCriarContaSms) return despacho(revelarCriarContaSms(false))

    despacho(revelarRemoverContaSms(false))
  }

  const handleFecharMensagem = (isSucesso = false) => {
    handleClose()
    setAlerta(ALERTAS.padrao)

    if (isSucesso) onFinish()
  }

  if (alerta?.open) {
    return alerta.titulo === 'Sucesso' ? (
      <MensagemSucesso
        handleMensagemSucesso={() => handleFecharMensagem(true)}
        mensagemTitulo={alerta.titulo}
        mensagemParagrafo1={alerta.mensagem}
        mensagemBotao="Fechar"
      />
    ) : alerta.titulo === 'Atenção' ? (
      <S.MessagemAtencaoWrapper>
        <MensagemAtencao
          handleMensagemAtencao={() => handleFecharMensagem()}
          mensagemTitulo={alerta.titulo}
          mensagemParagrafo1={alerta.mensagem}
          mensagemBotao="Fechar"
          centralizarBotao
          semBotaoCancelar
        />
      </S.MessagemAtencaoWrapper>
    ) : (
      <S.MessagemAtencaoWrapper>
        <MensagemErro
          handleMensagemErro={() => handleFecharMensagem()}
          mensagemTitulo={alerta.titulo}
          mensagemParagrafo1={alerta.mensagem}
          mensagemBotao="Fechar"
          centralizarBotao
        />
      </S.MessagemAtencaoWrapper>
    )
  }

  const tituloModal = revelarAlertaCriarContaSms
    ? 'Ativar conta SMS'
    : 'Desativar conta SMS'

  const mensagemModal = revelarAlertaCriarContaSms
    ? `Deseja ativar a conta SMS do usuário ${ds_pav_usuario}, portador do e-mail ${ds_email}?`
    : `Deseja desativar a conta SMS do usuário ${ds_pav_usuario}, portador do e-mail ${ds_email}?`

  return (
    <Modal width="360px" type="alerta" opened={isOpen} positionTitle="center">
      <S.ModalAlert>
        <S.TituloCriarSMS>{tituloModal}</S.TituloCriarSMS>
        <S.MensagemCriarSMS>{mensagemModal}</S.MensagemCriarSMS>
        <Group position="center">
          <Botao label="Cancelar" variant="outline" onClick={handleClose} />
          <Botao label="Confirmar" onClick={handleSubmit} />
        </Group>
      </S.ModalAlert>
    </Modal>
  )
}
